import commentsCa from "@/content/ca/comments.json";
import commentsEs from "@/content/es/comments.json";
import commentsEn from "@/content/en/comments.json";
import activityEs from "@/content/es/activity.json";
import activityCa from "@/content/ca/activity.json";
import activityEn from "@/content/en/activity.json";
import notesEn from "@/content/en/notes.json";
import notesCa from "@/content/ca/notes.json";
import notesEs from "@/content/es/notes.json";
// Common
import commonEn from "@/content/en/common.json";
import commonEs from "@/content/es/common.json";
import commonCa from "@/content/ca/common.json";

// Auth
import authEn from "@/content/en/auth.json";
import authEs from "@/content/es/auth.json";
import authCa from "@/content/ca/auth.json";

// Tasks
import tasksEn from "@/content/en/tasks.json";
import tasksEs from "@/content/es/tasks.json";
import tasksCa from "@/content/ca/tasks.json";

// Navigation
import navigationEn from "@/content/en/navigation.json";
import navigationEs from "@/content/es/navigation.json";
import navigationCa from "@/content/ca/navigation.json";

// Investors
import investorsEn from "@/content/en/investors.json";
import investorsEs from "@/content/es/investors.json";
import investorsCa from "@/content/ca/investors.json";

// Investments
import investmentsEn from "@/content/en/investments.json";
import investmentsEs from "@/content/es/investments.json";
import investmentsCa from "@/content/ca/investments.json";

// Calculator
import calculatorEn from "@/content/en/calculator.json";
import calculatorEs from "@/content/es/calculator.json";
import calculatorCa from "@/content/ca/calculator.json";

// Proposals
import proposalsEn from "@/content/en/proposals.json";
import proposalsEs from "@/content/es/proposals.json";
import proposalsCa from "@/content/ca/proposals.json";

// Beneficiaries
import beneficiariesEn from "@/content/en/beneficiaries.json";
import beneficiariesEs from "@/content/es/beneficiaries.json";
import beneficiariesCa from "@/content/ca/beneficiaries.json";

// Projects
import projectsEn from "@/content/en/projects.json";
import projectsEs from "@/content/es/projects.json";
import projectsCa from "@/content/ca/projects.json";

// Contracts
import contractsEn from "@/content/en/contracts.json";
import contractsEs from "@/content/es/contracts.json";
import contractsCa from "@/content/ca/contracts.json";

// Dashboard
import dashboardEn from "@/content/en/dashboard.json";
import dashboardEs from "@/content/es/dashboard.json";
import dashboardCa from "@/content/ca/dashboard.json";

// Settings
import settingsEn from "@/content/en/settings.json";
import settingsEs from "@/content/es/settings.json";
import settingsCa from "@/content/ca/settings.json";

// Notifications
import notificationsEn from "@/content/en/notifications.json";
import notificationsEs from "@/content/es/notifications.json";
import notificationsCa from "@/content/ca/notifications.json";

// Help
import helpEn from "@/content/en/help.json";
import helpEs from "@/content/es/help.json";
import helpCa from "@/content/ca/help.json";

// Organization
import organizationEn from "@/content/en/organization.json";
import organizationEs from "@/content/es/organization.json";
import organizationCa from "@/content/ca/organization.json";

// Templates
import templatesEn from "@/content/en/templates.json";
import templatesEs from "@/content/es/templates.json";
import templatesCa from "@/content/ca/templates.json";

// Invitation
import invitationEn from "@/content/en/invitation.json";
import invitationEs from "@/content/es/invitation.json";
import invitationCa from "@/content/ca/invitation.json";

// Investment Details
import investmentDetailsEn from "@/content/en/investment-details.json";
import investmentDetailsEs from "@/content/es/investment-details.json";
import investmentDetailsCa from "@/content/ca/investment-details.json";

// Admin (already separate)
import adminEn from "@/content/en/admin.json";
import adminEs from "@/content/es/admin.json";
import adminCa from "@/content/ca/admin.json";

// Hub (Investor Portal)
import hubEn from "@/content/en/hub.json";
import hubEs from "@/content/es/hub.json";
import hubCa from "@/content/ca/hub.json";

// AI Agent
import agentEn from "@/content/en/agent.json";
import agentEs from "@/content/es/agent.json";
import agentCa from "@/content/ca/agent.json";

// Classifications
import classificationsEs from "@/content/es/classifications.json";
import classificationsCa from "@/content/ca/classifications.json";
import classificationsEn from "@/content/en/classifications.json";

// Export modal
import exportEn from "@/content/en/export.json";
import exportEs from "@/content/es/export.json";
import exportCa from "@/content/ca/export.json";

// Generate-report modal (sibling of the export modal — templated PDFs)
import generateReportEn from "@/content/en/generate_report.json";
import generateReportEs from "@/content/es/generate_report.json";
import generateReportCa from "@/content/ca/generate_report.json";

// Merge all namespaces into a single 'translation' namespace for backward compatibility
// This maintains the original structure where code calls t('beneficiaries.title') etc.
const resources = {
  en: {
    translation: {
      ...commonEn,
      ...commentsEn,
      ...notesEn,
      ...authEn,
      ...navigationEn,
      ...tasksEn,
      ...activityEn,
      ...investorsEn,
      ...investmentsEn,
      ...calculatorEn,
      ...proposalsEn,
      ...beneficiariesEn,
      ...projectsEn,
      contracts: contractsEn.contracts,
      ...dashboardEn,
      ...settingsEn,
      ...notificationsEn,
      ...helpEn,
      ...organizationEn,
      ...templatesEn,
      ...invitationEn,
      ...investmentDetailsEn,
      ...adminEn,
      ...hubEn,
      ...agentEn,
      ...classificationsEn,
      ...exportEn,
      ...generateReportEn,
    },
  },
  es: {
    translation: {
      ...commonEs,
      ...commentsEs,
      ...notesEs,
      ...authEs,
      ...navigationEs,
      ...tasksEs,
      ...activityEs,
      ...investorsEs,
      ...investmentsEs,
      ...calculatorEs,
      ...proposalsEs,
      ...beneficiariesEs,
      ...projectsEs,
      contracts: contractsEs.contracts,
      ...dashboardEs,
      ...settingsEs,
      ...notificationsEs,
      ...helpEs,
      ...organizationEs,
      ...templatesEs,
      ...invitationEs,
      ...investmentDetailsEs,
      ...adminEs,
      ...hubEs,
      ...agentEs,
      ...classificationsEs,
      ...exportEs,
      ...generateReportEs,
    },
  },
  ca: {
    translation: {
      ...commonCa,
      ...commentsCa,
      ...notesCa,
      ...authCa,
      ...navigationCa,
      ...tasksCa,
      ...activityCa,
      ...investorsCa,
      ...investmentsCa,
      ...calculatorCa,
      ...proposalsCa,
      ...beneficiariesCa,
      ...projectsCa,
      contracts: contractsCa.contracts,
      ...dashboardCa,
      ...settingsCa,
      ...notificationsCa,
      ...helpCa,
      ...organizationCa,
      ...templatesCa,
      ...invitationCa,
      ...investmentDetailsCa,
      ...adminCa,
      ...hubCa,
      ...agentCa,
      ...classificationsCa,
      ...exportCa,
      ...generateReportCa,
    },
  },
};

export default resources;
